import { AsyncPipe } from '@angular/common';
import { ɵisPromise, ɵisSubscribable, Pipe, PipeTransform } from '@angular/core';
import { Observable, Subscribable } from 'rxjs';

@Pipe({
  name: 'optionalAsync',
  pure: false,
  standalone: true,
})
export class OptionalAsyncPipe extends AsyncPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override transform<T>(obj: null | undefined): undefined;
  public override transform<T>(obj: Observable<T> | Subscribable<T> | Promise<T> | T): T | undefined;
  public override transform<T>(obj: never): T | undefined {
    return ((ɵisSubscribable(obj) || ɵisPromise(obj)) ? super.transform<T>(obj) : obj) ?? undefined;
  }
}
